/*
 * Panier — personnalisation après l'ajout.
 *
 * Le panneau rendu par snippets/perso-cart-panel.liquid propose, sous une
 * peluche déjà au panier, les mêmes options que la fiche produit. Quand le
 * client valide, on reproduit ce que perso-cart-bridge.js fait à l'ajout
 * depuis la fiche, mais sur une ligne existante :
 *   1. la peluche reçoit (ou garde) son `_perso_group`, plus les propriétés
 *      des options incluses et la liste `_perso_options` — via /cart/change.js,
 *      qui REMPLACE toutes les propriétés : on relit celles de la ligne et on
 *      fusionne, sinon une perso ajoutée en deux fois effacerait la première ;
 *   2. les produits compagnons (qui portent le prix) partent en /cart/add.js
 *      avec ce même groupe.
 * Le panier obtenu est identique à celui de la fiche : la logistique et le
 * regroupement (perso-cart-group.js) ne voient pas la différence.
 *
 * Le tiroir se rafraîchit par l'événement `apps:product-added-to-cart`, que le
 * thème écoute ; la page panier se recharge.
 */
(function () {
  if (window.__persoCartAdd) return;
  window.__persoCartAdd = true;

  var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');

  function request(path, body) {
    var opts = { headers: { Accept: 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(root + path, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error((data && data.description) || path + ' refusé');
        return data;
      });
    });
  }

  function newGroupId() {
    return 'perso-' + Date.now().toString(36) + '-' + Math.floor(Math.random() * 1e6).toString(36);
  }

  // Choix déjà faits pour la ligne (perso-cart-panel.liquid, data-perso-existing).
  function existingOf(panel) {
    var el = panel && panel.querySelector('[data-perso-existing]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function setField(card, label, value) {
    var input = card && card.querySelector('[name="properties[' + label.replace(/"/g, '\\"') + ']"]');
    if (!input) return;
    input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  // Coche les options déjà choisies et remplit leurs champs ; décoche le reste
  // (l'option par défaut pré-cochée ne doit pas s'ajouter en douce).
  function prefill(panel) {
    var ex = existingOf(panel);
    var perso = panel.querySelector('perso-options');
    if (!ex || !perso || typeof perso.onToggle !== 'function' || panel.dataset.prefilled) return;
    panel.dataset.prefilled = '1';
    var handles = ex.handles || [];
    (perso.checkboxes || []).forEach(function (cb) {
      var want = handles.indexOf(cb.dataset.optionHandle) !== -1;
      if (cb.checked !== want && !cb.disabled) {
        cb.checked = want;
        perso.onToggle(cb);
      }
    });
    Object.keys(ex.companions || {}).forEach(function (h) {
      var cb = perso.querySelector('[data-perso-checkbox][data-option-handle="' + h + '"]');
      var card = cb && cb.closest('[data-perso-option]');
      var vals = ex.companions[h] || {};
      Object.keys(vals).forEach(function (label) { setField(card, label, vals[label]); });
    });
    Object.keys(ex.main || {}).forEach(function (key) {
      var parts = key.split(' — ');
      if (parts.length < 2) return;
      var title = parts.shift();
      var cb = (perso.checkboxes || []).filter(function (c) { return c.dataset.optionTitle === title; })[0];
      setField(cb && cb.closest('[data-perso-option]'), parts.join(' — '), ex.main[key]);
    });
    if (typeof perso.update === 'function') perso.update();
  }

  // Propriétés de la ligne sans aucune trace de perso (pour la remplacer).
  function withoutPerso(props) {
    var out = {};
    Object.keys(props || {}).forEach(function (k) {
      if (k.indexOf('_perso') === 0 || k.indexOf(' — ') !== -1) return;
      out[k] = props[k];
    });
    return out;
  }

  function stripPerso(props) {
    var out = {};
    Object.keys(props || {}).forEach(function (k) {
      if (k.indexOf('_perso') !== 0) out[k] = props[k];
    });
    return out;
  }

  function setBusy(btn, on) {
    if (!btn) return;
    btn.disabled = on;
    btn.classList.toggle('loading', on);
  }

  // Tiroir : feuille modale (<dialog>). Page panier : dépliage en place.
  function openPanel(panel, open) {
    var toggle = panel.querySelector('[data-perso-cart-toggle]');
    var sheet = panel.querySelector('[data-perso-cart-sheet]');
    if (sheet && typeof sheet.showModal === 'function') {
      if (open && !sheet.open) sheet.showModal();
      else if (!open && sheet.open) sheet.close();
    } else {
      var body = panel.querySelector('[data-perso-cart-body]');
      if (!body) return;
      body.hidden = !open;
    }
    panel.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function refresh(panel) {
    var drawer = panel.closest('.quick-cart');
    if (!drawer) {
      window.location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
    // Le thème remplace les lignes puis remet le défilement là où il était :
    // en bas, sur le formulaire qu'on vient de remplir. On remonte à la
    // peluche dès que l'ancien panneau a disparu du DOM (= rendu terminé).
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (document.contains(panel) && tries < 40) return;
      clearInterval(timer);
      var items = drawer.querySelector('.quick-cart__items');
      if (items) items.scrollTop = 0;
    }, 100);
  }

  // Fusion des propriétés de la ligne avec celles de la nouvelle perso.
  // `_perso_options` cumule les handles (attach rate lisible sur la peluche).
  function mergeProperties(existing, added, groupId) {
    var merged = Object.assign({}, existing || {}, added || {}, { _perso_group: groupId });
    var handles = []
      .concat(((existing && existing._perso_options) || '').split(','))
      .concat(((added && added._perso_options) || '').split(','))
      .filter(Boolean);
    if (handles.length) merged._perso_options = handles.join(',');
    return merged;
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-perso-cart-toggle]');
    if (toggle) {
      var p = toggle.closest('[data-perso-cart-panel]');
      var opening = toggle.getAttribute('aria-expanded') !== 'true';
      if (opening) prefill(p);
      openPanel(p, opening);
      return;
    }

    var cancel = e.target.closest && e.target.closest('[data-perso-cart-cancel]');
    if (cancel) {
      openPanel(cancel.closest('[data-perso-cart-panel]'), false);
      return;
    }

    var submit = e.target.closest && e.target.closest('[data-perso-cart-submit]');
    if (!submit) return;
    e.preventDefault();

    var panel = submit.closest('[data-perso-cart-panel]');
    var perso = panel && panel.querySelector('perso-options');
    if (!perso || typeof perso.validate !== 'function') return;

    var existing = existingOf(panel);
    var editing = !!(existing && (existing.handles || []).length);
    // En modification, tout décocher retire la personnalisation.
    if (!perso.hasSelection() && !editing) {
      perso.showError(panel.dataset.msgNone || '');
      return;
    }
    var validation = perso.validate();
    if (!validation.ok) {
      if (validation.firstInvalid) {
        try {
          validation.firstInvalid.focus();
        } catch (err) {
          /* sans conséquence */
        }
      }
      return;
    }

    var key = panel.dataset.lineKey;
    setBusy(submit, true);

    request('/cart.js')
      .then(function (cart) {
        var line = cart.items.filter(function (i) {
          return i.key === key;
        })[0];
        if (!line) throw new Error('ligne ' + key + ' absente du panier');

        // Plusieurs peluches identiques sur la ligne (Shopify les regroupe) :
        // la personnalisation ne vaut que pour UNE peluche (02/10). On la sort
        // de la ligne avec ses propriétés ; les autres restent, personnalisables
        // à leur tour.
        if (editing) {
          // Modifier : on retire les compagnons existants, on ajoute les nouveaux,
          // et la peluche reçoit des propriétés neuves (rien de l'ancienne perso).
          var gid = (line.properties && line.properties._perso_group) || newGroupId();
          var keys = existing.keys || [];
          var updates = {};
          keys.forEach(function (k) { updates[k] = 0; });
          var removeOld = keys.length ? request('/cart/update.js', { updates: updates }) : Promise.resolve();
          var hasSel = perso.hasSelection();
          var props = Object.assign(withoutPerso(line.properties), hasSel ? perso.getMainProperties() : {}, hasSel ? { _perso_group: gid } : {});
          var comps = hasSel ? perso.getCompanionItems(gid) : [];
          return removeOld
            .then(function () { return comps.length ? request('/cart/add.js', { items: comps }) : null; })
            .then(function () { return request('/cart/change.js', { id: key, quantity: line.quantity, properties: props }); });
        }

        var split = line.quantity > 1;
        var groupId = split ? newGroupId() : ((line.properties && line.properties._perso_group) || newGroupId());
        var properties = mergeProperties(split ? stripPerso(line.properties) : line.properties, perso.getMainProperties(), groupId);

        // Les compagnons d'abord : si l'ajout échoue (rupture), la peluche
        // garde ses propriétés d'origine et rien n'est à moitié fait.
        var companions = perso.getCompanionItems(groupId);
        var addCompanions = companions.length ? request('/cart/add.js', { items: companions }) : Promise.resolve();
        return addCompanions.then(function () {
          if (!split) {
            return request('/cart/change.js', { id: key, quantity: line.quantity, properties: properties });
          }
          return request('/cart/add.js', { items: [{ id: line.variant_id, quantity: 1, properties: properties }] })
            .then(function () {
              return request('/cart/change.js', { id: key, quantity: line.quantity - 1 });
            });
        });
      })
      .then(function () {
        openPanel(panel, false);
        refresh(panel);
      })
      .catch(function (err) {
        console.error('[perso] personnalisation depuis le panier impossible', err);
        setBusy(submit, false);
        perso.showError(panel.dataset.msgError || err.message || '');
      });
  });
})();
